import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import type { SellerFreightProvider } from '@shipstation/client-common/types/freight-providers';
import { useIsShipstationReturnsEnabled } from '../../hooks/use-seller-setting';
import { UNISHIPPERS_API_CODE, WWEX_API_CODE } from '../../pages/settings/carriers/freight/constants';
import Global from '../../store/global-selectors';

export type WwexFreightVariables = {
  hasWwexFreight: string;
  hasUnishippersFreight: string;
  features: string;
};

export const useWwexFreightVariables = (): WwexFreightVariables => {
  const sellerFreightProviders = useSelector(Global.selectSellerFreightProviders);
  const isShipstationReturnsEnabled = useIsShipstationReturnsEnabled();

  return useMemo(
    () => ({
      hasWwexFreight: (sellerFreightProviders as SellerFreightProvider[])
        .some((p) => p.providerCode?.toLowerCase() === WWEX_API_CODE)
        .toString(),
      hasUnishippersFreight: (sellerFreightProviders as SellerFreightProvider[])
        .some((p) => p.providerCode?.toLowerCase() === UNISHIPPERS_API_CODE)
        .toString(),
      features: JSON.stringify(isShipstationReturnsEnabled ? ['ShipstationReturns'] : []),
    }),
    [sellerFreightProviders, isShipstationReturnsEnabled],
  );
};
